export const DATE_FORMATS = {
  SHORT_YEAR_SLASH_DATE: 'DD/MM/YY',
  FULL_DATE: 'DD-MM-YYYY',
  REVERSE_DATE: 'YYYY-MM-DD',
  WEEK_DAY: 'DD-MMM',
}
